import { inject } from 'mobx-react';
import * as React from 'react';

import { BentoStore } from './bento-store';

import { traverseChildren } from './utils';

import { BentoPortion } from './bento-portion';

interface BentoSideDishProps {
  bento?: BentoStore;
}

@inject('bento')
export class BentoSideDish extends React.Component<BentoSideDishProps> {
  public componentWillMount() {
    const { bento } = this.props;
    if (!bento) {
      return;
    }

    traverseChildren(this, child => {
      if (child && child.type === BentoPortion) {
        bento.declareContent(child.props.name, child.props.children);

        return true;
      }

      return false;
    });
  }

  public render() {
    return null;
  }
}
